<script>
	// @ts-nocheck
	import { _ } from 'svelte-i18n';
	import logo from '$lib/images/logo/logo-kemenhut.png';
	import { browser } from '$app/environment';
	import { page } from '$app/stores';
	import { onMount } from 'svelte';
	import Language from '../components/Language.svelte';

	const pathname = $page.url.pathname;

	$: active_class = {
		home: pathname == '/' ? 'active' : '',
		berita: pathname == '/berita' ? 'active' : '',
		karhutla: '',
		publikasi: '',
		tentang_sipongi: ''
	};

	onMount(async () => {
		if (browser) {
			// Karhutla
			if (
				pathname == '/sebaran-titik-panas' ||
				pathname == '/indikasi-luas-kebakaran' ||
				pathname == '/emisi-co2' ||
				pathname == '/grafik-titik-panas'
			) {
				active_class.karhutla = 'active';
			}

			// Publikasi
			if (pathname == '/dokumen-lainnya' || pathname == '/peraturan-perundangan') {
				active_class.publikasi = 'active';
			}

			// Tentang Sipongi
			if (
				pathname == '/direktorat-pkhl' ||
				pathname == '/manggala-agni' ||
				pathname == '/struktur-organisasi'
			) {
				active_class.tentang_sipongi = 'active';
			}

			// Navbar shrink function
			var navbarShrink = function () {
				const navbarCollapsible = document.body.querySelector('#mainNav');

				if (!navbarCollapsible) {
					return;
				}
				if (window.scrollY === 0) {
					navbarCollapsible.classList.remove('navbar-shrink');
				} else {
					navbarCollapsible.classList.add('navbar-shrink');
				}

				try {
					const title_ = document.body.querySelector('#brand-text');
					if (window.scrollY === 0) {
						title_.classList.add('title-white');
						title_.classList.remove('title-dark');
					} else {
						title_.classList.add('title-dark');
						title_.classList.remove('title-white');
					}
				} catch (error) {}

				try {
					const lang_ = document.body.querySelector('#langID');
					if (window.scrollY === 0) {
						lang_.classList.add('title-white');
						lang_.classList.remove('title-dark');
					} else {
						lang_.classList.add('title-dark');
						lang_.classList.remove('title-white');
					}
				} catch (error) {}
			};

			// Shrink the navbar
			navbarShrink();

			// Shrink the navbar when page is scrolled
			document.addEventListener('scroll', navbarShrink);

			//  Activate Bootstrap scrollspy on the main nav element
			const mainNav = document.body.querySelector('#mainNav');
			if (mainNav) {
				new bootstrap.ScrollSpy(document.body, {
					target: '#mainNav',
					rootMargin: '0px 0px -40%'
				});
			}

			// Collapse responsive navbar when toggler is visible
			const navbarToggler = document.body.querySelector('.navbar-toggler');
			const responsiveNavItems = [].slice.call(
				document.querySelectorAll('#navbarResponsive .nav-link')
			);
			responsiveNavItems.map(function (responsiveNavItem) {
				responsiveNavItem.addEventListener('click', () => {
					if (window.getComputedStyle(navbarToggler).display !== 'none') {
						navbarToggler.click();
					}
				});
			});
		}
	});
</script>

<nav class="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
	<div class="container-fluid">
		<a class="navbar-brand me-0" href="/">
			<img src={$_('navigation.logo')} alt="Logo-kemenhut" style="
			height: auto;
			width: 125px;"/>
		</a>
		<a href="/" class="brand-tex text-decoration-none ps-2">
			<div class="brand-text title-white" id="brand-text">
				<div class="align-top" style="font-weight: normal;font-size:23px;">
					SiPongi<span style="vertical-align:super;font-size: large;">+</span>
				</div>
				<span style="font-size: 14px;">{$_('home.1')}</span>
			</div>
		</a>
		<button
			class="navbar-toggler"
			type="button"
			data-bs-toggle="collapse"
			data-bs-target="#navbarNavDropdown"
			aria-controls="navbarNavDropdown"
			aria-expanded="false"
			aria-label="Toggle navigation"
			>Menu
			<span class="navbar-toggler-icon" />
		</button>
		<div class="collapse navbar-collapse" id="navbarNavDropdown">
			<ul class="navbar-nav text-uppercase ms-auto py-4 py-lg-0">
				<li class="nav-item">
					<a class="nav-link {active_class.home}" aria-current="page" href="/">{$_('navigation.menu_1')}</a>
				</li>
				<li class="nav-item"><a class="nav-link" href="/peta">{$_('navigation.menu_2')}</a></li>
				<li class="nav-item">
					<div class="dropdown">
						<a
							class="nav-link dropdown-toggle {active_class.karhutla}"
							data-bs-toggle="dropdown"
							href={'#'}>{$_('navigation.menu_3')}</a
						>
						<ul class="dropdown-menu">
							<li>
								<a class="dropdown-item" href="/sebaran-titik-panas"
									>{$_('navigation.submenu_3.menu_1')}</a
								>
							</li>
							<li>
								<a class="dropdown-item" href="/grafik-titik-panas"
									>{$_('navigation.submenu_3.menu_2')}</a
								>
							</li>
							<li>
								<a class="dropdown-item" href="/indikasi-luas-kebakaran"
									>{$_('navigation.submenu_3.menu_3')}</a
								>
							</li>
							<li>
								<a class="dropdown-item" href="/emisi-co2"
									>{@html $_('navigation.submenu_3.menu_4')}</a
								>
							</li>
						</ul>
					</div>
				</li>
				<li class="nav-item">
					<div class="dropdown">
						<a
							class="nav-link dropdown-toggle {active_class.publikasi}"
							data-bs-toggle="dropdown"
							href={'#'}>{$_('navigation.menu_5')}</a
						>
						<ul class="dropdown-menu">
							<li>
								<a class="dropdown-item" href="/peraturan-perundangan"
									>{$_('navigation.submenu_5.menu_1')}</a
								>
							</li>
							<li>
								<a class="dropdown-item" href="/dokumen-lainnya"
									>{$_('navigation.submenu_5.menu_2')}</a
								>
							</li>
						</ul>
					</div>
				</li>
				<li class="nav-item">
					<a class="nav-link {active_class.berita}" href="/berita">{$_('navigation.menu_6')}</a>
				</li>
				<li class="nav-item">
					<div class="dropdown">
						<a
							class="nav-link dropdown-toggle {active_class.tentang_sipongi}"
							data-bs-toggle="dropdown"
							href={'#'}>{$_('navigation.menu_7')}</a
						>
						<ul class="dropdown-menu">
							<li>
								<a class="dropdown-item" href="/direktorat-pkhl-2"
									>{$_('navigation.submenu_7.menu_1')}</a
								>
							</li>
							<li>
								<a class="dropdown-item" href="/struktur-organisasi"
									>{$_('navigation.submenu_7.menu_3')}</a
								>
							</li>
							<li>
								<a class="dropdown-item" href="/hard-manggala-agni"
									>{$_('navigation.submenu_7.menu_2')}</a
								>
							</li>
						</ul>
					</div>
				</li>
				<li class="nav-item">
					<div class="dropdown">
						<a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href={'#'}
							>{$_('navigation.menu_4')}</a
						>
						<ul class="dropdown-menu" style="left: -46px;">
							<li>
								<a class="dropdown-item" rel="external" data-sveltekit-reload target="_blank" href="https://sipongi.menlhk.go.id/p32/"
									>{$_('navigation.submenu_4.menu_1')}</a
								>
							</li>
							<li>
								<a
									class="dropdown-item"
									rel="external"
									data-sveltekit-reload
									target="_blank"
									href="https://sipongi.menlhk.go.id/sipp-karhutla/"
									>{$_('navigation.submenu_4.menu_2')}</a
								>
							</li>
						</ul>
					</div>
				</li>
				<Language />
			</ul>
		</div>
	</div>
</nav>

<!-- Navigation-->
<!--
<nav class="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
    <div class="container">
        <a class="navbar-brand me-0" href="/">
            <img src="{logo}" alt="Logo" />
        </a>
        <a href="/" class="brand-tex text-decoration-none ps-2">
            <div class="brand-text title-white" id="brand-text">
                <div class="align-top" style="font-weight: normal;font-size:23px;">
                    SiPongi<span style="vertical-align:super;font-size: large;">+</span>
                </div>
                <span style="font-size: 14px;">{$_('home.1')}</span>
            </div>
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">Menu
            <i class="fas fa-bars ms-1"></i>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav text-uppercase ms-auto py-4 py-lg-0"> 
                <li class="nav-item"><a class="nav-link {active_class.home}" href="/">{$_('navigation.menu_1')}</a></li>
                <li class="nav-item"><a class="nav-link" href="/peta">{$_('navigation.menu_2')}</a></li>
                <li class="nav-item">
                    <div class="dropdown">
                        <a class="nav-link dropdown-toggle {active_class.karhutla}" data-bs-toggle="dropdown" href="{'#'}">{$_('navigation.menu_3')}</a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="/sebaran-titik-panas">{$_('navigation.submenu_3.menu_1')}</a></li>
                            <li><a class="dropdown-item" href="/grafik-titik-panas">{$_('navigation.submenu_3.menu_2')}</a></li>
                            <li><a class="dropdown-item" href="/indikasi-luas-kebakaran">{$_('navigation.submenu_3.menu_3')}</a></li>
                            <li><a class="dropdown-item" href="/emisi-co2">{@html $_('navigation.submenu_3.menu_4')}</a></li>
                        </ul>
                    </div>
                </li>
                <li class="nav-item">
                    <div class="dropdown">
                        <a class="nav-link dropdown-toggle {active_class.publikasi}" data-bs-toggle="dropdown" href="{'#'}">{$_('navigation.menu_5')}</a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="/peraturan-perundangan">{$_('navigation.submenu_5.menu_1')}</a></li>
                            <li><a class="dropdown-item" href="/dokumen-lainnya">{$_('navigation.submenu_5.menu_2')}</a></li>
                        </ul>
                    </div>
                </li>
                <li class="nav-item"><a class="nav-link {active_class.berita}" href="/berita">{$_('navigation.menu_6')}</a></li>
                <li class="nav-item">
                    <div class="dropdown">
                        <a class="nav-link dropdown-toggle {active_class.tentang_sipongi}" data-bs-toggle="dropdown" href="{'#'}">{$_('navigation.menu_7')}</a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" href="/direktorat-pkhl-2">{$_('navigation.submenu_7.menu_1')}</a></li>
                            <li><a class="dropdown-item" href="/struktur-organisasi">{$_('navigation.submenu_7.menu_3')}</a></li>
                            <li><a class="dropdown-item" href="/hard-manggala-agni">{$_('navigation.submenu_7.menu_2')}</a></li>
                        </ul>
                    </div>
                </li>
                <li class="nav-item">
                    <div class="dropdown">
                        <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="{'#'}">{$_('navigation.menu_4')}</a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" target="_blank" href="https://sipongi.menlhk.go.id/p32/">{$_('navigation.submenu_4.menu_1')}</a></li>
                            <li><a class="dropdown-item" target="_blank" href="http://sipongi.menlhk.go.id/sipp-karhutla/">{$_('navigation.submenu_4.menu_2')}</a></li>
                        </ul>
                    </div>
                </li>
                <Language />
            </ul>
        </div>
    </div>
</nav>
-->

<style>
	@import '../landing.css';

	#mainNav .navbar-nav .nav-item .nav-link {
		color: white;
	}

	.navbar-shrink .navbar-nav .nav-item .nav-link {
		color: white !important;
	}

	.navbar-shrink .navbar-nav .nav-item .nav-link:hover {
		color: #ffc800 !important;
	}

	.navbar-shrink .navbar-nav .nav-item .nav-link.active,
	.active {
		color: #ffc800 !important;
	}
</style>
